// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuItemsPlaceholder__item-container-d2bd4f {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 48px;
  padding: 0px 24px;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Placeholders/MenuItemsPlaceholder/MenuItemsPlaceholder.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;AACF","sourcesContent":[".item-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 48px;\n  padding: 0px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item-container": `MenuItemsPlaceholder__item-container-d2bd4f`,
	"itemContainer": `MenuItemsPlaceholder__item-container-d2bd4f`
};
module.exports = ___CSS_LOADER_EXPORT___;
